import { z } from 'zod';

export const STOCK_WAREHOUSES = ['us', 'kr'] as const;
export const StockWarehouseSchema = z.enum(STOCK_WAREHOUSES);
export type StockWarehouse = z.infer<typeof StockWarehouseSchema>;

export const WarehouseStockSchema = z.object({
  sellable: z.number(),
  tracked: z.boolean(),
});
export type WarehouseStock = z.infer<typeof WarehouseStockSchema>;

export const ProductStockSchema = z.object({
  itemId: z.uuid(),
  name: z.string(),
  category: z.string().nullable(),
  stock: z.object({ us: WarehouseStockSchema, kr: WarehouseStockSchema }),
  inStock: z.boolean(),
});
export type ProductStock = z.infer<typeof ProductStockSchema>;

export const ProductStockLookupSchema = z.object({
  query: z.string(),
  matches: z.array(ProductStockSchema),
  alternatives: z.array(ProductStockSchema),
});

export const OpenOrderItemStockSchema = ProductStockSchema.extend({
  quantity: z.number().nullable(),
  heldForOrder: z.boolean(),
  outOfStock: z.boolean(),
  alternatives: z.array(ProductStockSchema),
});

export const OpenOrderStockSchema = z.object({
  orderNumber: z.string().nullable(),
  status: z.string(),
  paymentStatus: z.string(),
  parcelStatus: z.string(),
  warehouse: StockWarehouseSchema.nullable(),
  items: z.array(OpenOrderItemStockSchema),
});

export const ProductStockResultSchema = z.object({
  products: z.array(ProductStockLookupSchema),
  openOrders: z.union([
    z.object({ identified: z.literal(true), orders: z.array(OpenOrderStockSchema) }),
    z.object({ identified: z.literal(false), reason: z.string() }),
  ]),
  lastShippedOrder: OpenOrderStockSchema.nullable(),
});
export type ProductStockResult = z.infer<typeof ProductStockResultSchema>;
